import PublicHome from "./PublicHome";

/**
 * Public address search at `/`.
 *
 * Signed-in users stay here when they click the QLS logo or Dashboard from a
 * portal. Post-login landing is handled by AuthContainer / RoleBasedNavigation
 * — do not bounce `/` back to the portal or the logo/Dashboard toggle breaks.
 */
const Index = () => {
  return <PublicHome />;
};

export default Index;
